

export function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    // If you use react-router's navigate, you might do:
    // useNavigate cannot be used here since it's outside React components
    // Instead, use window.location or history
    window.location.href = "/login";
}
